document.addEventListener('DOMContentLoaded', function () {
if (!customElements.get('custom-header')) {
        customElements.define('custom-header', class CustomHeader extends HTMLElement {
            constructor() {
                super(); 
                
                this.setNavigation(this);
                this.menuTypeHandler();

                window.themeCore.EventBus.listen("cart:updated", (e) => {
                    this.updateItemCount(e);    
			    });
            }

            updateItemCount(event) {
                if (!event.hasOwnProperty("item_count")) {
                    return;
                }

                const headerCartItemCount = this.querySelector('.js-header-cart-item-count');
                const headerCartItemCountWrapper = this.querySelector('.header__cart-count');

                headerCartItemCountWrapper.setAttribute('data-cart-count', event.item_count);

                headerCartItemCount.innerHTML = event.item_count;

                if (event.item_count > 99) {
                    headerCartItemCount.innerHTML = "99+";
                } else {
                    headerCartItemCount.innerHTML = event.item_count;
                }
            }

            setNavigation(){
                const menuBtn = this.querySelector('.menu-button');
                const menu = this.querySelector('.menu');
            
                menuBtn.addEventListener('click', e => menuHandler(e));
            
                function menuHandler(e){ 
                    if(menu.getAttribute('isopen') == 'true'){
                        closeMenu();
                    }else{
                        openMenu();
                    }
                }
            
                function closeMenu(){
                    setTimeout(() => {
                        menu.style.display = 'none';
                        menu.setAttribute("isopen", false);
                    }, 500);
                    menu.style.opacity = '0';         
                }
                
                function openMenu(){
                    menu.setAttribute("isopen", true);
                
                    menu.style.display = 'flex';
                        setTimeout(() => {
                            menu.style.opacity = '1';
                    }, 10);
                
                }
            }


            menuTypeHandler(){
                let prevScrollPos = window.pageYOffset;
                const header = document.querySelector('.header').parentElement;
                const menu = document.querySelector('.menu');
                header.style.transform = 'translateY(0)';
                header.classList.add('sticky-header');
                
                const animatedMenu = () => {       
                    if(window.matchMedia('(max-width: 991px)').matches){ 
                        if(menu.getAttribute('isopen') != 'true'){
                            const currentScrollPos = window.pageYOffset;
                            let isAtTop = true;
                            
                            if (prevScrollPos > currentScrollPos) {
                                // Scrolling up
                                header.style.transform = 'translateY(0)';
                                isAtTop = false;
                            } else if(!isAtTop || currentScrollPos > 0) {
                                // Scrolling down            
                                header.style.transform = 'translateY(-100%)';
                            }
                
                            prevScrollPos = currentScrollPos;
                        }
                    }else{
                        header.style.transform = 'translateY(0)';
                    }
                }

                window.addEventListener('scroll', animatedMenu);
            }      
        })
    }

    if (!customElements.get('card-grids-container')) {
        customElements.define('card-grids-container', class CardGridsContainer extends HTMLElement {
            constructor() {
                super(); 

                this.init();
            }

            init() {
                const dots = this.querySelectorAll('.card-dot');
                const row = this.querySelector('.cards-grid__row');
                const cards = row.querySelectorAll('.cards-grid__column');

                dots.forEach(dot => {
                dot.addEventListener('click', () => {
                    const card = this.querySelector(`.cards-grid__column[data-id='${dot.getAttribute('data-id')}']`);
                    const cardWidth = card.offsetWidth;

                    row.scrollTo({
                    left: cardWidth * (parseInt(dot.getAttribute('data-id'), 10) - 1) +
                            ((parseInt(dot.getAttribute('data-id'), 10) - 1) * 16),
                    behavior: 'smooth'
                    });
                });
                });

                row.addEventListener('scroll', () => {
                    const scrollLeft = row.scrollLeft;
                    const cardCount = cards.length;
                    const cardWidth = this.querySelector(`.cards-grid__column`).offsetWidth + 16;

                    // determine active index (0-based)
                    let activeIndex = Math.round(scrollLeft / cardWidth);
                    if (activeIndex >= cardCount) activeIndex = cardCount - 1;

                    // reset all
                    cards.forEach(c => c.classList.remove('active'));
                    dots.forEach(d => d.classList.remove('active'));

                    // add active class
                    const activeCard = cards[activeIndex];
                    const activeDot = dots[activeIndex];

                    if (activeCard) activeCard.classList.add('active');
                    if (activeDot) activeDot.classList.add('active');
                });

            }
        })
    }

    if (!customElements.get('accordion-group')) {
        customElements.define('accordion-group', class AccordionGroup extends HTMLElement {
            constructor() {
                super(); 

                this.btn = this.querySelector('.faqs-button-wrapper button');
                this.init();
            }

            init() {            
                if(!this.btn) return;
                
                this.btn.addEventListener('click', () => {
                    this.classList.add('all-faqs');
                })
            }
        })
    }
})